import React, { Component } from "react";
import { observer } from "mobx-react";
import {
  fn_currOrderType,
  fn_AllOrderComplete,
  fn_completeList,
} from "../../../function/FnBodyOrder";
import {
  analyticeEvent,
  baerminUseYn,
  posOrderTab,
  kdsSetYn,
} from "utils/Utils";
import {
  fn_bridge_baemin_agency_login,
  fn_bridge_close,
  fn_bridge_pos_order_list,
  fn_bridge_incomplete_menu,
} from "function/FnPosBridge";
import { fn_ygy_holiday_setting } from "function/FnBodySetting";
import BaeminOnIcon from "static-file/images/baeminOn.png";
import BaeminOffIcon from "static-file/images/baeminOff.png";
import BaeminFailIcon from "static-file/images/baeminFail.png";
import { Link } from "react-router-dom";
@observer
class OrderSearchLeftView extends Component {
  render() {
    const { rootStore } = this.props;

    let currOrderType = rootStore.searchStore.getCurrOrderType;
    let orderType = rootStore.searchStore.getOrderTypeObj;
    let endOrderType = rootStore.searchStore.getEndOrderTypeObj;
    let img_icon =
      baerminUseYn(rootStore) &&
      rootStore.searchStore.getSession.connPosNo ==
        rootStore.settingStore.getBaeminUseStatus.baeminUsePosNo
        ? rootStore.settingStore.getBaeminStatus.login
          ? BaeminOnIcon
          : BaeminOffIcon
        : BaeminFailIcon;

    let arr = [];
    arr = [
      { type: "all", value: "전체", index: "1" },
      { type: "delivery", value: "배달", index: "2" },
      { type: "pickupAndTable", value: "포장/매장", index: "3" },
    ];

    let baeminStatus = false;
    if (
      baerminUseYn(rootStore) &&
      rootStore.searchStore.getSession.connPosNo ==
        rootStore.settingStore.getBaeminUseStatus.baeminUsePosNo
    ) {
      baeminStatus = true;
    }

    return (
      <ul id="leftMenu">
        {/* li class on 추가 */}
        <li
          className={
            rootStore.settingStore.getManagerSetting?.orderEnd == "N"
              ? "on"
              : ""
          }
          onClick={(event) => {
            event.preventDefault();
            analyticeEvent(
              "dashboardTab",
              "dashboardTabInProgress Button",
              "Button"
            );
            rootStore.settingStore.setManagerSetting("orderEnd", "N");
            rootStore.orderStore.setInitPage();
            if (posOrderTab(rootStore)) {
              fn_bridge_pos_order_list(rootStore);
            } else {
              fn_currOrderType(
                rootStore,
                rootStore.searchStore.getCurrOrderType
              );
            }
          }}
        >
          <div className="m1">
            <span className="ico"></span>
            <span className="txt">처리중</span>
            <span className="num">
              {rootStore.searchStore.getOrderTypeObjCount("all")}
            </span>
          </div>
        </li>
        <li
          className={
            rootStore.settingStore.getManagerSetting?.orderEnd == "Y"
              ? "on"
              : ""
          }
          onClick={(event) => {
            event.preventDefault();
            analyticeEvent(
              "dashboardTab",
              "dashboardTabCompleted Button",
              "Button"
            );
            rootStore.settingStore.setManagerSetting("orderEnd", "Y");
            rootStore.orderStore.setInitPage();
            if (posOrderTab(rootStore)) {
              fn_bridge_pos_order_list(rootStore);
            } else {
              fn_currOrderType(
                rootStore,
                rootStore.searchStore.getCurrOrderType
              );
            }
          }}
        >
          <div className="m2">
            <span className="ico"></span>
            <span className="txt">완료/취소</span>
            <span className="num">
              {rootStore.searchStore.getEndOrderTypeObj.all}
            </span>
          </div>
        </li>
        <ul
          className={
            rootStore.settingStore.getProgressingExposeFlag == "Y" &&
            kdsSetYn(rootStore)
              ? ""
              : "btnList"
          }
        >
          {rootStore.settingStore.getYgyUseStatus == "Y" &&
          rootStore.settingStore.getMainPosType == "Y" ? (
            baeminStatus ? (
              <li
                className={
                  rootStore.settingStore.getAgencyHolidayState
                    ? "complete ygy off"
                    : "complete ygy"
                }
                onClick={(event) => {
                  event.preventDefault();
                  fn_ygy_holiday_setting(rootStore);
                }}
              ></li>
            ) : (
              <li
                className={
                  rootStore.settingStore.getAgencyHolidayState
                    ? "complete ygy move off"
                    : "complete ygy move"
                }
                onClick={(event) => {
                  event.preventDefault();
                  fn_ygy_holiday_setting(rootStore);
                }}
              ></li>
            )
          ) : null}
          {baeminStatus ? (
            rootStore.settingStore.getBaeminStatus.live ? (
              <li
                className="complete baemin"
                onClick={(event) => {
                  event.preventDefault();
                  fn_bridge_close(rootStore);
                  fn_bridge_baemin_agency_login(rootStore);
                }}
              ></li>
            ) : (
              <li
                className="complete baemin off"
                onClick={(event) => {
                  event.preventDefault();
                  fn_bridge_close(rootStore);
                  fn_bridge_baemin_agency_login(rootStore);
                }}
              ></li>
            )
          ) : (
            ""
          )}
          {kdsSetYn(rootStore) ? (
            rootStore.settingStore.getProgressingExposeFlag == "Y" ? (
              <li
                className="incomplete"
                onClick={(event) => {
                  analyticeEvent(
                    "viewIncompleteMenu",
                    "viewIncompleteMenu Button",
                    "Button"
                  );
                  rootStore.viewStore.setIncompleteMenuNewTime(
                    rootStore.timerStore.currentTime?.toLocaleDateString() +
                      " " +
                      rootStore.timerStore.currentTime?.toLocaleTimeString()
                  );
                  fn_bridge_incomplete_menu(rootStore);
                  rootStore.layerStore.setIncompleteMenu(true);
                }}
              ></li>
            ) : null
          ) : null}
        </ul>
        <li
          className={
            rootStore.settingStore.getManagerSetting?.orderEnd == "Y"
              ? "complete disabled"
              : "complete"
          }
          onClick={(event) => {
            {
              rootStore.settingStore.getManagerSetting?.orderEnd == "Y"
                ? ""
                : fn_AllOrderComplete(rootStore);
            }
          }}
        ></li>
      </ul>
    );
  }
}

export default OrderSearchLeftView;
